import cn from 'classnames'
import dynamic from 'next/dynamic'
import React, { memo } from 'react'
// import { InsightsContainer } from 'src/components/AlspEnhancedDetailContainer/InsightsContainer/InsightsContainer'
// import { OverviewContainer } from 'src/components/AlspEnhancedDetailContainer/OverviewContainer/OverviewContainer'
// import { ReviewsContainer } from 'src/components/ReviewsContainer/ReviewsContainer'
// import { SolutionEnhancedPricing } from 'src/components/SolutionsPage/SolutionEnhancedPricing/SolutionEnhancedPricing'
// import { SolutionEnhancedVideos } from 'src/components/SolutionsPage/SolutionEnhancedVideos/SolutionEnhancedVideos'
import {
  IAlspSolutionDataFragment,
  ISimilarSolutionItemFragment,
  ITestimonialItemFragment,
} from 'src/graphql/generated/hooks'

import {
  CASE_TAB,
  DETAILS_TAB,
  PRICING_TAB,
  PRODUCT_BRIEFING_TAB,
  RESOURCE_TAB,
  VENDOR_ANALYSIS_TAB,
  VIDEOS_TAB,
} from '../../types'
import SkeletonLoading from '../SkeletonLoading/SkeletonLoading'
// import { ThemeOnly } from '../global/ThemeOnly'
// import { SolutionCaseStudies } from '../SolutionsPage/SolutionCaseStudies/SolutionCaseStudies'
import SolutionVendorAnalysisContainer from '../SolutionsPage/SolutionVendorAnalysisContainer/SolutionVendorAnalysisContainer'
// import { Testimonials } from '../Testimonials/Testimonials'

interface AlspEnhancedDetailContainerProps {
  className?: string
  alsp: IAlspSolutionDataFragment
  tabIdx: number
  similars: ISimilarSolutionItemFragment[]
  analysisTotal: number
  productBriefingTotal: number
  testimonials?: ITestimonialItemFragment[]
  relatedContent?: any[]
  totalRelatedContent?: number
}

const OverviewContainer = dynamic(
  () =>
    import('src/components/AlspEnhancedDetailContainer/OverviewContainer/OverviewContainer').then(
      (mod) => mod.OverviewContainer,
    ),
  {
    loading: () => <SkeletonLoading className="bg-navy" />,
  },
)
// const ReviewsContainer = dynamic(
//   () => import('src/components/ReviewsContainer/ReviewsContainer').then((mod) => mod.ReviewsContainer),
//   {
//     loading: () => <SkeletonLoading className="bg-navy" />,
//   },
// )
const SolutionCaseStudies = dynamic(
  () => import('../SolutionsPage/SolutionCaseStudies/SolutionCaseStudies').then((mod) => mod.SolutionCaseStudies),
  {
    loading: () => <SkeletonLoading className="bg-navy" />,
  },
)
const SolutionEnhancedVideos = dynamic(
  () =>
    import('src/components/SolutionsPage/SolutionEnhancedVideos/SolutionEnhancedVideos').then(
      (mod) => mod.SolutionEnhancedVideos,
    ),
  {
    loading: () => <SkeletonLoading className="bg-navy" />,
  },
)
const SolutionEnhancedPricing = dynamic(
  () =>
    import('src/components/SolutionsPage/SolutionEnhancedPricing/SolutionEnhancedPricing').then(
      (mod) => mod.SolutionEnhancedPricing,
    ),
  {
    loading: () => <SkeletonLoading className="bg-navy" />,
  },
)
const InsightsContainer = dynamic(
  () =>
    import('src/components/AlspEnhancedDetailContainer/InsightsContainer/InsightsContainer').then(
      (mod) => mod.InsightsContainer,
    ),
  {
    loading: () => <SkeletonLoading className="bg-navy" />,
  },
)

/**
 * Primary UI component for user interaction
 */
export const AlspEnhancedDetailContainer: React.FC<AlspEnhancedDetailContainerProps> = memo(
  ({
    className,
    alsp,
    tabIdx,
    similars,
    analysisTotal,
    productBriefingTotal,
    relatedContent,
    totalRelatedContent,
    // testimonials,
  }) => {
    // console.log('alsp-enhanced-detail-container::alsp?.vendorResources ', alsp?.vendorResources)
    const showInsightsTab = (alsp?.vendorResources || []).length > 0
    const randomNum = alsp?.slug ? alsp.slug : Math.floor(Math.random() * 1000) // Generates a number between 0 and 999

    return (
      <div className={cn(className, 'flex flex-col justify-center w-full px-5')}>
        {tabIdx === DETAILS_TAB && (
          <OverviewContainer
            key={randomNum + 'OverviewContainer'}
            alsp={alsp}
            similars={similars || []}
            relatedContent={relatedContent || []}
            totalRelatedContent={totalRelatedContent}
          />
        )}
        {/* {tabIdx === REVIEWS_TAB && (
          <ReviewsContainer
            key={randomNum + 'ReviewsContainer'}
            reviews={alsp?.reviews?.filter((review) => review != null) || []}
            isShowSubmit={true}
            title={alsp?.displayName || ''}
            solutionType={IEnum_Solution_Type.Alsp}
            id={alsp?.documentId || ''}
            isProgressing={false}
            isEnhanced={true}
          />
        )} */}
        {tabIdx === CASE_TAB && (
          <SolutionCaseStudies
            key={randomNum + 'SolutionCaseStudies'}
            caseStudies={alsp?.alspData?.enhancedListingData?.caseStudies ?? []}
          />
        )}
        {tabIdx === VIDEOS_TAB && (
          <SolutionEnhancedVideos
            key={randomNum + 'SolutionEnhancedVideos'}
            screenshots={alsp?.alspData?.enhancedListingData?.screenshots || []}
            videos={alsp?.alspData?.enhancedListingData?.videos || []}
          />
        )}
        {tabIdx === PRICING_TAB && (
          <SolutionEnhancedPricing key={randomNum + 'SolutionEnhancedPricing'} solution={alsp} />
        )}
        {showInsightsTab && tabIdx === RESOURCE_TAB && (
          <InsightsContainer key={randomNum + 'InsightsContainer'} alsp={alsp} />
        )}
        {tabIdx === VENDOR_ANALYSIS_TAB && (
          <SolutionVendorAnalysisContainer
            key={randomNum + 'SolutionVendorAnalysisContainer'}
            solutionId={alsp.documentId || ''}
            analysisTotal={analysisTotal}
          />
        )}
        {tabIdx === PRODUCT_BRIEFING_TAB && (
          <>
            <SolutionVendorAnalysisContainer
              key={randomNum + '-AlspEnhancedDetailContainer-SolutionProductBriefingContainer'}
              solutionId={alsp.documentId || ''}
              analysisTotal={productBriefingTotal}
              documentType="Product Briefing"
            />
          </>
        )}
        {/* <ThemeOnly theme="legaltech">
        <Testimonials testimonials={testimonials || []} />
      </ThemeOnly> */}
      </div>
    )
  },
)
